<script setup lang="ts">
  import { useAppModal } from '@/components/modal'
  import { useBuybackCreate } from '@/models/buyback'
  import BuybackForm from '../buyback-form.vue'

  const emit = defineEmits<{
    (e: 'created'): void,
  }>()

  const { form, errors, submitting, submitForm } = useBuybackCreate()
  const { modal, open, close } = useAppModal(() => {
    form.buy_back_items = ['']
  })
  defineExpose({ open })

  const submit = async () => {
    const response = await submitForm()

    if (response != null) {
      emit('created')
      close()
    }
  }

</script>

<template>
  <app-modal
    ref="modal"
    title="Tambah Buyback">
    <buyback-form
      v-model="form"
      :errors="errors"
      :submitting="submitting"
      @close="close"
      @submit="submit" />
  </app-modal>
</template>
